import styled from "styled-components";

export const WhyChooseSecWrapper = styled.div`
  .whyChoose_row {
    margin: -10px;
    .whyChoose_col {
      width: 50%;
      padding: 10px;
      @media (max-width: 1199px) {
        width: 100%;
      }
    }
    .whyChhoseLeft {
      text-align: left;
      @media (max-width: 1199px) {
        text-align: center;
      }
      h2 {
        font-weight: 300;
        font-size: 36px;
        @media (max-width: 1199px) {
          font-size: 30px;
        }
        @media (max-width: 899px) {
          font-size: 22px;
        }
        span {
          font-weight: 800;
          color: rgb(255, 24, 24);
        }
      }
      p {
        font-weight: 500;
        font-size: 20px;
        @media (max-width: 899px) {
          font-size: 16px;
        }
        @media (max-width: 599px) {
          font-size: 14px;
        }
        &.trusted_partner_text {
          font-weight: 600;
          font-size: 24px;
          margin: 25px 0;
          @media (max-width: 899px) {
            margin: 12px auto;
            font-size: 18px;
          }
          @media (max-width: 599px) {
            font-size: 15px;
          }
        }
      }
      .choose_figure {
        max-width: 428px;
        margin: 55px 0 45px;
        @media (max-width: 1199px) {
          margin: 25px auto;
        }
        @media (max-width: 899px) {
          margin: 15px auto;
          max-width: 320px;
        }
        @media (max-width: 599px) {
          max-width: 260px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .know_more_btn {
        min-height: 65px;
        @media (max-width: 1199px) {
          max-width: 50%;
          margin: 0 auto;
          min-height: 52px;
        }
        @media (max-width: 599px) {
          max-width: 100%;
        }
      }
    }
    .whyChhoseRht {
      display: flex;
      align-items: center;
      transition: all 0.4s ease-in-out;
      @media (max-width: 1199px) {
        max-width: 100%;
        padding-left: 0;
        padding-top: 30px;
      }
      .slick-slider {
        overflow: hidden;
        .slick-list {
          margin: -10px;
          @media (max-width: 1199px) {
            margin: -5px;
          }
          .slick-slide {
            opacity: 0.6;
            transition: 0.4s ease-in-out;
            &.slick-current {
              opacity: 1;
            }
          }
          .whyChoose_List {
            position: relative;
            display: flex !important;
            align-items: center;
            flex-wrap: wrap;
            padding: 10px;
            height: 100px;
            @media (max-width: 1199px) {
              height: 80px;
              padding: 5px;
            }
            i {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              border-radius: 50%;
              font-style: normal;
              width: 80px;
              height: 80px;
              margin-right: 24px;
              background: rgb(255, 24, 24);
              font-weight: 800;
              font-size: 64px;
              color: rgb(255, 235, 235);
              @media (max-width: 1199px) {
                width: 60px;
                height: 60px;
                margin-right: 12px;
                font-size: 30px;
              }
              @media (max-width: 899px) {
                width: 50px;
                height: 50px;
                font-size: 20px;
              }
            }
            span {
              width: calc(100% - 104px);
              font-family: "Inter";
              font-weight: 500;
              font-size: 24px;
              color: rgb(30, 30, 30);
              @media (max-width: 1199px) {
                width: calc(100% - 72px);
                font-size: 20px;
              }
              @media (max-width: 899px) {
                width: calc(100% - 62px);
                font-size: 16px;
              }
            }
            &:not(:last-child) {
              margin-bottom: 25px;
              @media (max-width: 1199px) {
                margin-bottom: 20px;
              }
              @media (max-width: 899px) {
                margin-bottom: 15px;
              }
              @media (max-width: 599px) {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
`;
